import { createElement } from 'react';
import { convertChildren } from '../../utils/children-node-handle';
import './index.scss';
import likePng from '../../assets/icon/review-list/like.png';
import unlikePng from '../../assets/icon/review-list/unlike.png';
const ReviewList = ({ dataList = [], children, ...otherProps }) => {
    const _otherProps = otherProps || {};
    console.log('评价列表数据：', dataList);
    return (createElement("div", { className: "reviewList", ..._otherProps },
        createElement("div", { className: "header" },
            createElement("div", { class: "header-title" }, "Customer Reviews"),
            createElement("div", { class: "header-right" }, "All Reviews")),
        createElement("div", { className: "list" }, dataList ? (dataList.map((item, index) => (createElement("div", { key: index, className: "review-item" },
            createElement("div", { className: "userInfo" },
                convertChildren(children, 'avatar', {
                    imgSrc: item.avatar[0],
                    style: {
                        width: '45px',
                        height: '45px',
                    },
                }),
                createElement("div", { className: "userDetail" },
                    createElement("div", { className: "topLine" },
                        convertChildren(children, 'userName', {
                            children: item.userName,
                            className: 'userDetail-username',
                        }),
                        convertChildren(children, 'time', {
                            children: item.time,
                            className: 'userDetail-username',
                        })),
                    convertChildren(children, 'rating', { children: item.rating }))),
            convertChildren(children, 'content', {
                children: item.content,
                className: 'content',
            }),
            createElement("div", { className: "actions" },
                createElement("span", { className: "action" },
                    createElement("img", { className: "action-img", src: likePng, alt: "" }),
                    createElement("span", null, item.likeCount)),
                createElement("span", { className: "action" },
                    createElement("img", { className: "action-img", src: unlikePng, alt: "" }),
                    createElement("span", null, item.unlikeCount))))))) : (createElement("div", null, "\u6682\u65E0\u6570\u636E")))));
};
export default ReviewList;
